import axios from 'axios'
import store from '@/store'
import { MessageBox } from 'mint-ui';
import router from '@/router'
import { getToken,removeToken} from '@/utils/auth'
// import { indexOf } from 'core-js/core/array';

var url = ''
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, //"https://sale.xmkxy.cn/api/",
  timeout: 360000 // request timeout
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      if(!config.params){
        config.params = {}
      }
      config.params['token'] = getToken()
    }
    url = config.url 
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  async response => {
    const res = response.data
    if (response.status !== 200||res.code!='000000') {
      if(res.code=='401'){ 
        removeToken()
        // 刷新界面
        location.reload();
      }else{
        const href = window.location.href
        if(url.indexOf('getByDate')==-1&&url.indexOf('getView')==-1){ 
          MessageBox({
            title: '提示',
            message: href.indexOf('orderView')>-1?'数据不存在，或已被删除':res.mesg,
            showClose: false, 
            closeOnClickModal: false ,
            type: 'error',
          }).then(action => {
          }).catch(err => {
          })
        }
      }
      
      //  if(url.indexOf('login')>-1){
      //   return Promise.reject(new Error(res.mesg || 'Error'))
      //  }
      return res//Promise.reject(new Error(res.mesg || 'Error'))
    } else {  
      return res
    }
  },
  error => {
    MessageBox({
        title: '提示',
        message: "登录错误",
        showClose: false, 
        closeOnClickModal: false ,
        type: 'error',
      }).then(action => {
         if(res.data.indexOf('重新登录')>-1){
           removeToken()
           // 刷新界面
           location.reload();
         }
      }).catch(err => {
      })
    
    return Promise.reject(error)
  }
)

export default service
